<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils title="Gerar Nota Fiscal"/>
            <breadcrumb
                    :items="[{label: 'Pesquisar Notas', path: '/invoices'}, {label: 'Gerar Nota Fiscal', path: $router.currentRoute.path}]"/>

            <form @submit.prevent.stop="submit" novalidate>
                <ibox type="tab_right">
                    <template v-slot:title>
                        <h5 v-if="!$appUtils.isMobile()"><svg-icon icon="file-invoice-dollar"/></h5>
                    </template>

                    <template v-slot:tabs>
                        <Tabs :tabs="tabs" @onTabSelected="onTabSelected"/>
                    </template>

                    <template v-slot:content>
                        <transition name="tab" mode="out-in">
                            <TakerServiceTab
                                    :entity="entity"
                                    :errors="errors"
                                    :mode="tabModes"
                                    :key="'taker_service_tab'"
                                    @onReset="reset"
                                    :selected-proposals="selectedProposals"
                                    v-if="currentTab === 0"/>
                            <ServicesValueTab
                                    :entity="entity"
                                    :errors="errors"
                                    :mode="tabModes"
                                    :key="'services_value_tab'"
                                    :selected-proposals="selectedProposals"
                                    v-if="currentTab === 1"/>
                        </transition>
                    </template>
                    <template v-slot:footer>
                        <div class="container-fluid-grid" v-if="tabModes.service === 'normal' && tabModes.taker === 'edit'">
                            <div class="row">
                                <div class="col t-r">
                                    <span class="btn-group btn-group-sm" role="group">
                                        <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon icon="sync"/> Limpar</button>
                                        <router-link to="/invoices" class="btn btn-dark btn-sm"><svg-icon icon="search"/> Pesquisar</router-link>
                                        <button type="button"
                                                @click="validateInvoice"
                                                :disabled="$appUtils.moneyToFloat(entity.total_value) <= 0"
                                                class="btn btn-theme-1 btn-sm"><svg-icon icon="check"/> Prosseguir</button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                </ibox>
            </form>

            <ModalConfirmation :show="showConfirmation"
                               :entity="entity"
                               :sending-invoice="sendingInvoice"
                               @onSendInvoice="confirmSend"
                               @onClose="showConfirmation = false" />
        </template>
    </DefaultTmpl>
</template>

<script>
    import CRUDEdit from '@/mixins/CRUDEdit'
    import Tabs from "../../components/particles/Tabs";
    import DefaultTmpl from "../../templates/DefaultTmpl";
    import ServicesValueTab from "./ServicesValueTab";
    import TakerServiceTab from "./TakerServiceTab";
    import {createNamespacedHelpers} from 'vuex'
    import dayjs from "dayjs";
    const {mapActions} = createNamespacedHelpers('invoices');

    export default {
        name: "InvoicesEdit",
        components: {
            Tabs,
            DefaultTmpl,
            ServicesValueTab,
            TakerServiceTab,
            ModalConfirmation: () => import('./ModalConfirmation')
        },
        mixins: [
            CRUDEdit.mount('invoices')
        ],
        data() {
            return {
                tabs: [{
                    icon: 'info-circle',
                    label: 'Tomador de Serviços',
                    active: true
                }, {
                    icon: 'product-hunt',
                    label: 'Serviços e Valores',
                    active: false
                }],
                currentTab: 0,
                tabModes: {
                    taker: 'easy',
                    service: 'normal'
                },
                errors: {},
                selectedProposals: {},
                showConfirmation: false,
                sendingInvoice: false,
                draftToken: null,
            }
        },
        methods: {
            ...mapActions(['validate', 'loadDraft']),
            onTabSelected(tab) {
                this.currentTab = tab.index;
            },
            // Preenche o formulário a partir de um rascunho preparado por um agente MCP.
            // A emissão continua manual: o usuário revisa e clica em enviar normalmente.
            applyDraftIfPresent() {
                const token = this.$route.query.draft;
                if (!token) return;

                this.draftToken = token;
                this.loadDraft(token)
                    .then(({invoice}) => {
                        const outer = this;
                        Object.keys(invoice || {}).forEach(k => {
                            outer.$set(outer.entity, k, invoice[k]);
                        });

                        const links = invoice && invoice.invoice_proposals_attributes;
                        if (Array.isArray(links)) {
                            links.forEach(p => outer.$set(outer.selectedProposals, p.proposal_id, true));
                        }

                        // Mesmo comportamento do fluxo de autocomplete (loadInvoiceData):
                        // sem isso o formulário preenchido fica oculto atrás da busca 'easy'.
                        this.tabModes.taker = 'edit';

                        this.$snotify.info('Rascunho carregado. Revise os dados e emita a nota.', 'Nota preparada por IA');
                    })
                    .catch(() => {
                        this.$snotify.warning('O rascunho não foi encontrado ou expirou (validade de 10 minutos).', 'Rascunho indisponível');
                    });
            },
            onAfterRouteEnter() {
                this.applyDraftIfPresent();
            },
            afterReset() {
                this.tabs.forEach(t => t.active = false);
                this.tabs[0].active = true;
                this.tabModes.taker = 'easy';
                this.tabModes.service = 'normal';
                this.selectedProposals = {};
                this.errors = {};
                this.currentTab = 0;
            },
            createEntity() {
                const mold = {
                    id: null,
                    replace_id: null,
                    document_type: 'cnpj',
                    document: null,
                    inscricao_municipal: null,
                    taker_name: null,
                    phone: null,
                    email: null,
                    postal_code: null,
                    address: null,
                    address_number: null,
                    address_notes: null,
                    city_ibge_code: '4314902',
                    neighborhood: null,
                    competence: dayjs().format('DD/MM/YYYY'),
                    state_code: 'RS',
                    service_code: '100901001',
                    is_iss_retention: false,
                    description: 'Comissão referente a prestação de serviços de intermediação de negócios abaixo:\n',
                    total_value: 0,
                    inference_value: 0,
                    conditional_discount_value: 0,
                    unconditional_discount_value: 0,
                    inss_value: 0,
                    ir_value: 0,
                    pis_value: 0,
                    cofins_value: 0,
                    csll_value: 0,
                    other_retentions_value: 0,
                };

                const outer = this;
                Object.keys(mold).forEach(k => {
                    outer.$set(outer.entity, k, mold[k]);
                });
            },
            validateInvoice() {
                this.errors = {};
                this.validate(this.entity)
                    .then(() => {
                        this.showConfirmation = true;
                    })
                    .catch(this.httpErrorResult)
            },
            confirmSend() {
              const isReplacing = this.$route.query.mode === 'replace';

              const title = isReplacing ? 'Confirmar Substituição' : 'Confirmar';
              const body = isReplacing
                  ? 'A NFS-e anterior será substituída por esta nova, que será enviada à prefeitura. Deseja continuar?'
                  : 'A Nota Fiscal será enviada para a prefeitura, deseja continuar?';

                this.$store.commit('addModal', {
                    title: title,
                    size: 'small',
                    body: body,
                    buttons: [{
                        type: 'ok',
                        class: 'btn btn-danger btn-sm',
                        method: id => {
                            this.$store.commit('destroyModal', id);
                            this.sendInvoice();
                        }
                    }, {
                        type: 'close',
                        label: 'Não',
                        focus: true,
                        method: id => this.$store.commit('destroyModal', id)

                    }]
                })
            },
            sendInvoice() {
                this.sendingInvoice = true;
                this.errors = {};

                const entity = {...this.entity};
                const keys = Object.keys(this.selectedProposals);

                if (keys.length > 0) {
                    entity.invoice_proposals_attributes = keys.map(k => {
                        return {proposal_id: k}
                    });
                }

                // Fecha o loop do handoff (16b): repassa o token do rascunho.
                if (this.draftToken) entity._draft_token = this.draftToken;

                this.save(entity)
                    .then(() => {
                        this.$snotify.success('Nota gerada com sucesso!', this.$appStorage.getUser().name);
                        this.showConfirmation = false;
                    })
                    .catch(e => {
                      console.error('falha no envio', e);
                        this.httpErrorResult(e);
                    })
                    .finally(() => this.sendingInvoice = false);
            },
            httpErrorResult({response}) {
                this.$appUtils.vibrate();
                if (response.status === 422) {
                    Object.keys(response.data).forEach(k => {
                        this.$set(this.errors, k, response.data[k]);
                    });

                    if (response.data.base) {
                      this.$snotify.warning(response.data.base.join('\n'), 'Validação');
                    } else {
                      this.$snotify.warning('Verifique os dados informados', 'Validação');
                    }
                } else if (response.status === 403) {
                    this.$snotify.error('Você não possui permissão para executar essa ação', 'Permissão')
                } else {
                    this.$snotify.error('Ops... Aconteceu algum problema inesperado. Tente novamente e caso o problema persista, contate o suporte.', 'Falha')
                }
            },
          onAfterRouteUpdate() {
              this.selectedProposals = {};
              this.tabModes.taker = 'easy';

              this.currentTab = 0;
              this.tabs[0].active = true;
              this.tabs[1].active = false;
          }
        },
    }
</script>
